export default {
  namespaced: true,
  state: {
    ready: false
  },
  mutations: {
    updateReady(state, ready) {
      state.ready = ready;
    }
  },
  actions: {
    ready({ commit }) {
      commit('updateReady', true);
    },
    reset({ commit }) {
      commit('updateReady', false);
    }
  },
  getters: {
    isReady(state) {
      return state.ready;
    }
  }
};
